const webviewInterface = (key: string, data?: object) => {
  const payload = data as { data?: string };

  if (window.webkit?.messageHandlers) {
    return window.webkit.messageHandlers[key].postMessage(payload);
  }

  if (window.Android) {
    if (
      key === 'open' ||
      key === 'openWithMyTab' ||
      key === 'openFullWebView'
    ) {
      payload.data = payload.data?.replace('/', '');
    }

    if (data) {
      return window.Android[key](JSON.stringify(payload || {}));
    }

    return window.Android[key]();
  }
};

const closeWebview = () => webviewInterface('close');

// 앱 웹뷰 안인지(네이티브 브릿지가 있는지)
const isNativeApp = () => !!(window.webkit?.messageHandlers || window.Android);

// 네이티브 헤더 없는 풀스크린 웹뷰로 연다(게임 등). path 는 '/games/apple' 형태
const openFullWebView = (path: string) =>
  webviewInterface('openFullWebView', { data: path });

export { webviewInterface, closeWebview, isNativeApp, openFullWebView };
